
















import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import SelectItem from '@/common/SelectItem';

@Component({})
export default class CustomSelect extends Vue {
  @Model('change', { default: null })
  public current: SelectItem;

  @Prop({ required: true })
  public all: SelectItem[];

  @Prop()
  public zIndex: number;

  public opened = false;

  public toggle() {
    if (this.all.length > 1) {
      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  public open() {
    this.opened = true;
    document.body.addEventListener('click', this.close);
  }

  public close() {
    this.opened = false;
    document.body.removeEventListener('click', this.close);
  }

  public select(item: SelectItem) {
    this.$emit('change', item);
  }
}

